import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// Components
const createSwiper = (element) => {
	const mode = element.dataset.swiper;
	const slides = element.querySelectorAll('.swiper-slide');
	const canLoop = mode === 'single' && slides.length > 1;
	const shell = element.closest('[data-swiper-shell]');
	const pagination = shell?.querySelector('.swiper-pagination') ?? element.querySelector('.swiper-pagination');

	return new Swiper(element, {
		modules: [Autoplay, Pagination],
		slidesPerView: mode === 'cards' ? 1.15 : 1,
		spaceBetween: mode === 'cards' ? 24 : 12,
		loop: canLoop,
		autoplay: canLoop
			? {
					delay: 3500,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				}
			: false,
		pagination: {
			el: pagination,
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: mode === 'cards' ? 2.25 : 1,
				spaceBetween: mode === 'cards' ? 28 : 16,
			},
			1024: {
				slidesPerView: mode === 'cards' ? 3.2 : 1,
				spaceBetween: 32,
			},
		},
	});
};

document.querySelectorAll('[data-swiper]').forEach((element) => {
	createSwiper(element);
});

document.querySelectorAll('[data-swiper-mobile]').forEach((element) => {
	const mediaQuery = window.matchMedia('(max-width: 767px)');
	let swiper = null;

	const syncSwiper = () => {
		if (mediaQuery.matches && !swiper) {
			element.dataset.swiper = element.dataset.swiperMobile;
			swiper = createSwiper(element);
		}

		if (!mediaQuery.matches && swiper) {
			swiper.destroy(true, true);
			swiper = null;
			delete element.dataset.swiper;
		}
	};

	syncSwiper();
	mediaQuery.addEventListener('change', syncSwiper);
});

document.addEventListener('click', (event) => {
	const trigger = event.target.closest('[data-lightbox-item]');

	if (!trigger) {
		return;
	}

	event.preventDefault();

	const galleryName = trigger.dataset.lightboxGallery;
	const galleryItems = Array.from(document.querySelectorAll('[data-lightbox-item]'))
		.filter((item) => item.dataset.lightboxGallery === galleryName && item.getClientRects().length);
	const items = galleryItems
		.filter((item) => item.dataset.src)
		.map((item) => ({
			src: item.dataset.src,
			alt: item.dataset.alt ?? '',
			caption: item.dataset.caption ?? '',
		}));
	const index = galleryItems.indexOf(trigger);

	window.dispatchEvent(new CustomEvent('lido-lightbox-open', {
		detail: {
			gallery: galleryName,
			items,
			index: Math.max(0, index),
		},
	}));
});

// Global
window.Alpine = Alpine;

Alpine.data('lidoLightbox', () => ({
	open: false,
	items: [],
	index: 0,
	get current() {
		return this.items[this.index] ?? null;
	},
	show(detail) {
		this.items = detail.items ?? [];
		this.index = detail.index ?? 0;
		this.open = this.items.length > 0;
		document.documentElement.classList.toggle('has-lightbox', this.open);
	},
	close() {
		this.open = false;
		document.documentElement.classList.remove('has-lightbox');
	},
	next() {
		if (!this.items.length) {
			return;
		}

		this.index = (this.index + 1) % this.items.length;
	},
	previous() {
		if (!this.items.length) {
			return;
		}

		this.index = (this.index - 1 + this.items.length) % this.items.length;
	},
}));

// Inits
Alpine.start();
